export const Footer = () => {
    return (
        <></>
    );
};